/** Small Thai text helpers for the customer panel. */
import { shortDate } from './inbox'

export function daysSince(iso: string | null, nowMs: number): number | null {
  if (!iso) return null
  return Math.max(0, Math.floor((nowMs - Date.parse(iso)) / 86400000))
}

/** "ปกติทุก ~2 สัปดาห์" / "ปกติทุก ~5 วัน" */
export function intervalText(days: number | null): string | null {
  if (days === null) return null
  if (days >= 7) return `ปกติทุก ~${Math.round(days / 7)} สัปดาห์`
  return `ปกติทุก ~${days} วัน`
}

/** Only worth a warning when the gap is clearly longer than the customer's usual cycle. */
export function gapText(lastIso: string | null, usualDays: number | null, nowMs: number): string | null {
  const d = daysSince(lastIso, nowMs)
  if (d === null) return null
  const usual = usualDays ?? 14
  return d > usual * 1.5 ? `ห่างหายไป ${d} วัน` : null
}

export const dateOrDash = (iso: string | null): string => (iso ? shortDate(iso) : '—')

export function followUpTitle(minutes: number): string {
  if (minutes % 60 === 0) return `ทักตามถ้าลูกค้าเงียบ ${minutes / 60} ชั่วโมง`
  return `ทักตามถ้าลูกค้าเงียบ ${minutes} นาที`
}
